import cn from 'classnames'
import styles from './button.module.scss'

/**
 * @param {{
 *   variant?: 'primary'|'secondary'|'ghost',
 *   size?: 'md'|'sm',
 *   type?: 'button'|'submit'|'reset',
 *   disabled?: boolean,
 *   loading?: boolean,
 *   onClick?: (event: React.MouseEvent) => void,
 *   children: React.ReactNode,
 *   className?: string,
 *   ariaLabel?: string
 * }} props
 */
export function Button({
    variant = 'primary',
    size = 'md',
    type = 'button',
    disabled = false,
    loading = false,
    onClick,
    children,
    className,
    ariaLabel
}) {
    return (
        <button
            type={type}
            className={cn(styles.btn, styles[variant], styles[size], className, {[styles.loading]: loading})}
            disabled={disabled || loading}
            onClick={onClick}
            aria-label={ariaLabel}
            aria-busy={loading || undefined}
        >
            <span className={styles.label}>{children}</span>
        </button>
    )
}
